import { FreshnessStatus, TimePeriod } from '@/__generated__/graphql';
import { toTitleCase } from '../string';

interface FreshnessInfo {
  /** 10 */
  count?: number | null;
  /** hour */
  period?: TimePeriod | null;
}

const getFreshnessStr = (params: FreshnessInfo | null | undefined) => {
  if (params == null) return null;
  const { count, period } = params;
  if (count == null || period == null) return null;

  return `${count} ${period}${count !== 1 ? 's' : ''}`;
};

export const toFreshnessStatus = (
  status: string | null | undefined,
): FreshnessStatus =>
  status ? (toTitleCase(status) as FreshnessStatus) : FreshnessStatus.Unknown;

interface FreshnessCriteria {
  warnAfter?: FreshnessInfo | null;
  errorAfter?: FreshnessInfo | null;
}

export const getFreshnessCriteriaStr = (
  criteria: FreshnessCriteria | null | undefined,
) => {
  const warn = getFreshnessStr(criteria?.warnAfter);
  const error = getFreshnessStr(criteria?.errorAfter);
  if (warn == null && error == null) return null;
  const warnStr = warn ? `Warn: ${warn}` : null;
  const errorStr = error ? `Error: ${error}` : null;
  if (warnStr && errorStr) {
    return `${warnStr}, ${errorStr}`;
  }
  if (warnStr) return warnStr;
  return errorStr;
};

export const STALE_FRESHNESS_THRESHOLD_IN_DAYS = 30;

export const computeSourceFreshness = (
  freshness: {
    freshnessStatus: string | null;
    snapshottedAt: string | null;
  } | null,
) => {
  if (!freshness) {
    return null;
  }
  return freshness.freshnessStatus ?? null;
};

export const isFreshnessCheckConfigured = (
  freshness: {
    freshnessStatus: string | null;
    snapshottedAt: string | null;
  } | null,
): boolean => {
  if (!freshness) return false;
  const { freshnessStatus, snapshottedAt } = freshness;
  return !!freshnessStatus && !!snapshottedAt;
};
